// src/types/archetype.types.ts
export type ArchetypeId = "heartbeat" | "moments" | "safehaven";

export interface ArchetypeVisualTheme {
  primary: string;
  secondary: string;
  accent: string;
  glow: string;
  bg: string;
  activeBg: string;
  border: string;
  gradient: string;
}

export interface LoadingScreenConfig {
  style: "romantic" | "luxury" | "playful" | "minimal" | "cinematic" | "intimate" | "sacred";
  message: string;
  progressMessages: string[];
  icon: "heart" | "sparkle" | "flower" | "gift" | "candle" | "sunrise";
  backgroundColor: string;
  particleCount: number;
}

export interface ProposalConfig {
  enabled: boolean;
  question: string;
  yesButtonText: string;
  noButtonTexts: string[];
  floatingHearts: boolean;
  confetti: boolean;
  delayBeforeButtons?: number;
}

export interface LetterConfig {
  style:
    | "ceremonial"
    | "playful"
    | "heartfelt"
    | "reflective"
    | "elegant"
    | "romantic"
    | "minimal"
    | "sacred";
  paperTexture: string;
  seal: boolean;
}

export interface BouquetConfig {
  receiveButtonText: string;
  showValue: boolean;
}

export interface DefaultCardData {
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  [key: string]: any;
}

export interface ArchetypeConfig {
  id: ArchetypeId;
  name: string;
  description: string;
  visualPersonality: string;
  loadingScreen: LoadingScreenConfig;
  proposal?: ProposalConfig;
  letter: LetterConfig;
  bouquet: BouquetConfig;
  defaultCardData: DefaultCardData;
}

export const ARCHETYPE_THEMES: Record<ArchetypeId, ArchetypeVisualTheme> = {
  moments: {
    primary: "#f9ca24",
    secondary: "#f6e58d",
    accent: "#f0932b",
    glow: "bg-yellow-400/50",
    bg: "bg-yellow-500/[0.05]",
    activeBg: "bg-yellow-600/[0.12]",
    border: "border-yellow-500/40",
    gradient: "from-yellow-500/10",
  },
  heartbeat: {
    primary: "#ff4d6d",
    secondary: "#ff8fa3",
    accent: "#ffb3c6",
    glow: "bg-red-400/50",
    bg: "bg-red-500/[0.05]",
    activeBg: "bg-red-600/[0.12]",
    border: "border-red-500/40",
    gradient: "from-red-500/10",
  },
  safehaven: {
    primary: "#a5b1c2",
    secondary: "#778ca3",
    accent: "#4b6584",
    glow: "bg-blue-400/50",
    bg: "bg-blue-500/[0.05]",
    activeBg: "bg-blue-600/[0.12]",
    border: "border-blue-500/40",
    gradient: "from-blue-500/10",
  },
};
